import { css } from 'styled-components';

export const iconElementBasePositioning = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;
